import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = "service_nxaraxm";
const EMAILJS_TEMPLATE_ID = "template_zee9bgj";
const EMAILJS_PUBLIC_KEY = "ECNOBncrKsqc5zcQU";
const ADMINISTRACION_EMAIL = "administracion@fisp.org.ar";
const MARKETING_EMAIL = "marketing@fisp.org.ar";

const SERVICE_OPTIONS = [
    { value: "Wellness Corporativo", label: "Wellness Corporativo" },
    { value: "Proyectos Tecnológicos en Salud", label: "Proyectos Tecnológicos en Salud" },
    { value: "Marketing y Publicidad en Salud", label: "Marketing y Publicidad en Salud" },
    { value: "Servicios Médicos", label: "Servicios Médicos" },
    {
        value: "Producción de contenido y cobertura de eventos",
        label: "Producción y Cobertura de Eventos",
    },
    {
        value: "Capacitación laboral para la industria de la salud",
        label: "Capacitación Laboral",
    },
    {
        value: "Políticas Públicas e Inteligencia Institucional",
        label: "Políticas Públicas e Inteligencia Institucional",
    },
    { value: "Varios", label: "Varios" },
];

const MARKETING_SERVICES = new Set([
    "Marketing y Publicidad en Salud",
    "Producción de contenido y cobertura de eventos",
]);

const createInitialForm = (serviceName = "") => ({
    nombre: "",
    empresa: "",
    emailCorporativo: "",
    servicio: serviceName,
    mensaje: "",
});

export default function ServiceCta({ service, id = "contacto" }) {
    const initialService = service?.title || "";
    const [formData, setFormData] = useState(() => createInitialForm(initialService));
    const [submitStatus, setSubmitStatus] = useState("idle");

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((current) => ({ ...current, [name]: value }));
        if (submitStatus !== "idle") {
            setSubmitStatus("idle");
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (submitStatus === "sending") {
            return;
        }

        setSubmitStatus("sending");
        const recipient = MARKETING_SERVICES.has(formData.servicio)
            ? MARKETING_EMAIL
            : ADMINISTRACION_EMAIL;

        try {
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                {
                    email: recipient,
                    nombre: formData.nombre.trim(),
                    empresa: formData.empresa.trim(),
                    email_corporativo: formData.emailCorporativo.trim(),
                    servicio: formData.servicio,
                    mensaje: formData.mensaje.trim() || "Sin mensaje adicional.",
                },
                EMAILJS_PUBLIC_KEY,
            );
            setFormData(createInitialForm(initialService));
            setSubmitStatus("success");
        } catch (error) {
            console.error("No se pudo enviar la consulta de servicios:", error);
            setSubmitStatus("error");
        }
    };

    return (
        <section className="cta" id={id}>
            <div className="cta-inner">
                <h2>Empecemos a trabajar.</h2>
                <p className="cta-sub">
                    Completá el formulario y nuestro equipo se pone en contacto en menos de 24 horas para armar una propuesta a medida.
                </p>
                <form className="cta-form-wrap" onSubmit={handleSubmit}>
                    <div className="fg">
                        <label htmlFor={`${id}-nombre`}>Nombre y apellido</label>
                        <input
                            id={`${id}-nombre`}
                            name="nombre"
                            type="text"
                            placeholder="Ej: María González"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="fg">
                        <label htmlFor={`${id}-empresa`}>Empresa / Institución</label>
                        <input
                            id={`${id}-empresa`}
                            name="empresa"
                            type="text"
                            placeholder="Nombre de la empresa"
                            value={formData.empresa}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="fg">
                        <label htmlFor={`${id}-email`}>Email corporativo</label>
                        <input
                            id={`${id}-email`}
                            name="emailCorporativo"
                            type="email"
                            placeholder="nombre@empresa.com"
                            value={formData.emailCorporativo}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="fg">
                        <label htmlFor={`${id}-servicio`}>Servicio de interés</label>
                        <select
                            id={`${id}-servicio`}
                            name="servicio"
                            value={formData.servicio}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccioná un servicio</option>
                            {SERVICE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="fg">
                        <label htmlFor={`${id}-mensaje`}>Mensaje (opcional)</label>
                        <textarea
                            id={`${id}-mensaje`}
                            name="mensaje"
                            rows="3"
                            placeholder="Contanos brevemente sobre tu proyecto..."
                            value={formData.mensaje}
                            onChange={handleChange}
                        />
                    </div>
                    <button className="btn-submit" type="submit" disabled={submitStatus === "sending"}>
                        {submitStatus === "sending" ? "Enviando..." : "Enviar consulta"}
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            aria-hidden="true"
                        >
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>
                    {submitStatus === "success" || submitStatus === "error" ? (
                        <p className={`cta-form-status is-${submitStatus}`} aria-live="polite">
                            {submitStatus === "success"
                                ? "Consulta enviada correctamente."
                                : "No pudimos enviar la consulta. Intentá nuevamente."}
                        </p>
                    ) : null}
                </form>
            </div>
        </section>
    );
}
